import { CONSULTATION_TYPE } from '@abiglobalhealth/go-types'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ConsultationIcon } from '@/components/Consultation/components/ConsultationIcon'
import { RxIcon } from '@/components/icons/RxIcon'
import { useConsultationType } from '@/hooks/useConsultationType'
import { useIsConsultationType } from '@/hooks/useIsConsultationType'
import { useModule } from '@/hooks/useModule'
import { useStep } from '@/hooks/useStep'

export const SurveyProgress = () => {
  const { t } = useTranslation()
  const { currentModule } = useModule()

  if (!('steps' in currentModule!)) return null

  const { currentStep } = useStep()
  const { consultationType } = useConsultationType()
  const isPrescription = useIsConsultationType(CONSULTATION_TYPE.PRESCRIPTION)
  const [currentStepIndex, setCurrentStepIndex] = useState(0)
  const totalSteps = Object.keys(currentModule?.steps!).length

  useEffect(() => {
    const current = Object.keys(currentModule?.steps!).findIndex((stepId) => stepId === String(currentStep?.id))
    setCurrentStepIndex(current + 1)
  }, [currentStep])

  return (
    <div className="flex flex-col gap-4 p-4" data-testid="survey-progress-container">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {isPrescription ? (
            <RxIcon customClassName="text-primary h-6" />
          ) : (
            <ConsultationIcon consultationType={consultationType} customClassName="h-5 text-primary" />
          )}
          <p className="font-bold">{t(currentModule?.name!)}</p>
        </div>
        <span className="text-sm">{`${currentStepIndex}/${totalSteps}`}</span>
      </div>

      <div className="relative h-2 w-full rounded-full bg-white" data-testid="survey-progress-bar-container">
        <span
          data-testid="survey-progress-bar-fill"
          className="bg-primary absolute h-full rounded-full transition-[width]"
          style={{
            width: `${(currentStepIndex / totalSteps) * 100}%`
          }}
        />
      </div>
    </div>
  )
}
